import { captureAuthOperationGuard } from '@/utils/auth-operation-guard';
import { getWalletTokenBalance } from '@/api/trade';

/** 余额只读请求统一交给服务端；失败不得伪装成查询到零余额。 */
export async function readWalletTokenBalance(contract, address, chainId) {
  const assertSession = captureAuthOperationGuard();
  const result = await getWalletTokenBalance({ contract, address, chainId: Number(chainId) });
  assertSession();
  const balance = Number(result?.balance);
  if (result?.balance == null || !Number.isFinite(balance) || balance < 0) {
    throw new Error('Invalid wallet balance response');
  }
  return balance;
}
